import React, { useEffect } from 'react';
import { TrackingClient } from '@sparefoot/tracking-client';
import isBrowser from 'utils/isBrowser';

function withPageViewTracking(pageTypeOrFn) {
	return (Component) => {
		const WithPageViewTracking = (props) => {
			useEffect(() => {
				if (isBrowser() && TrackingClient) {
					const resolvedPageType =
						typeof pageTypeOrFn === 'function'
							? pageTypeOrFn(props)
							: pageTypeOrFn;
					const metaTitle = document.title || resolvedPageType;
					TrackingClient.trackPageView({
						page_name: metaTitle,
						page_type: resolvedPageType,
					});
				}
			}, []);

			return <Component {...props} />;
		};
		WithPageViewTracking.displayName = `withPageViewTracking(${Component.displayName || Component.name || 'Component'})`;
		return WithPageViewTracking;
	};
}

export default withPageViewTracking;
